const SOC2_REPORT_ROOT = '/soc2-report';

const route = (segment: string, title: string) => ({
  segment,
  title,
  path: segment ? `${SOC2_REPORT_ROOT}/${segment}` : SOC2_REPORT_ROOT,
  relativePath: segment ? `/${segment}` : '/',
});

export const SOC2_REPORT_ROUTES = {
  root: route('', 'Generate Report'),
  unapproved: route('unapproved', 'Unapproved PRs'),
  syncStatus: route('sync-status', 'Sync Status'),
} as const;

const SOC2_REPORT_SUBMENU_ROUTES = [
  SOC2_REPORT_ROUTES.unapproved,
  SOC2_REPORT_ROUTES.syncStatus,
];

export const SOC2_REPORT_SUBMENU_ITEMS = SOC2_REPORT_SUBMENU_ROUTES.map(
  ({ path: to, title }) => ({ title, to }),
);
